export const V = {
  bg:     '#0a0a0c',
  bg2:    '#111114',
  bg3:    '#18181c',
  // Gold: #c9a84c  |  Rose Gold Option C tried: #d4956a  |  Rose Gold Option E tried: #c9906e
  gold:   '#c9a84c',
  goldL:  '#d4b86a',
  sage:   '#7aab8a',
  rose:   '#c47a7a',
  sky:    '#7a9ec4',
  lav:    '#9a7ac4',
  border: 'rgba(201,168,76,0.15)',
  text:   '#f0ede6',
  muted:  'rgba(240,237,230,0.5)',
  dim:    'rgba(240,237,230,0.22)',
};

export const serif   = { fontFamily: "'Cormorant Garamond', serif" };
export const mono    = { fontFamily: "'DM Mono', monospace", fontVariantNumeric: 'slashed-zero' };
export const eyebrow = { fontSize: '11px', letterSpacing: '0.14em', color: V.gold, textTransform: 'uppercase', fontWeight: 500 };
export const card    = { background: V.bg2, border: `0.5px solid ${V.border}`, borderRadius: '10px', padding: '18px 20px', marginBottom: '14px', maxWidth: '100%', boxSizing: 'border-box' };
export const btnGold  = { padding: '12px 28px', background: 'rgba(201,168,76,0.1)', border: '0.5px solid rgba(201,168,76,0.4)', borderRadius: '8px', color: V.goldL, fontSize: '13px', letterSpacing: '0.08em', cursor: 'pointer', fontWeight: 500 };
export const btnGhost = { padding: '10px 20px', background: 'transparent', border: `0.5px solid ${V.border}`, borderRadius: '8px', color: V.muted, fontSize: '13px', cursor: 'pointer' };

export const TIER2_SESSION_CODE = `TIER2-${Math.floor(100000 + Math.random() * 900000)}`;

export function xpToLevel(xp) {
  if (xp < 300)  return { level: 1, title: 'Curious Observer' };
  if (xp < 700)  return { level: 2, title: 'Market Student' };
  if (xp < 1200) return { level: 3, title: 'Apprentice Seller' };
  if (xp < 2000) return { level: 4, title: 'Option Strategist' };
  if (xp < 3000) return { level: 5, title: 'Confident Trader' };
  return          { level: 6, title: 'Sovereign Trader' };
}
